'use client';

import React, { useState } from "react";
import { errText, postWithRetry } from "./api";
import { AField, AInput, AError, ABtn, ALink } from "./authUi";

export const LoginForm = ({ onAuthed, onSignup, onForgot, onJoin }) => {
  const [phone, setPhone] = useState("");
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const { data } = await postWithRetry("/auth/login", { phone, pin });
      onAuthed(data);
    } catch (err) {
      setError(errText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4">
      <div>
        <h2 className="text-xl font-semibold tracking-tight text-zinc-900">Welcome back</h2>
        <p className="mt-1 text-sm text-zinc-500">Log in with your mobile number and PIN.</p>
      </div>
      <AError>{error}</AError>
      <AField label="Mobile number">
        <AInput
          data-testid="login-phone-input"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="98xxxxxxxx"
          inputMode="numeric"
          autoComplete="tel"
        />
      </AField>
      <AField label="PIN">
        <AInput
          data-testid="login-pin-input"
          value={pin}
          onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 6))}
          placeholder="••••"
          type="password"
          inputMode="numeric"
          autoComplete="current-password"
        />
      </AField>
      <ABtn data-testid="login-submit-button" type="submit" busy={busy}>
        Log in
      </ABtn>
      <div className="flex items-center justify-between pt-1">
        <ALink data-testid="login-signup-link" onClick={onSignup}>
          New here? Create your account
        </ALink>
        <ALink data-testid="login-forgot-link" onClick={onForgot}>
          Forgot PIN?
        </ALink>
      </div>
      {onJoin && (
        <div className="border-t border-zinc-200 pt-3 text-center">
          <ALink data-testid="login-join-link" onClick={onJoin}>
            Been invited to a team? Join your team
          </ALink>
        </div>
      )}
    </form>
  );
};
